import { BaseIcon } from '../BaseIcon';
import type { SizedIconProps } from '../BaseIcon';
import { IconSize } from '../../../../enums/IconSize';

type InfoIconProps = Omit<SizedIconProps, 'children'>;

const PathDefinition = () => (
  <path d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M9,12H7V7h2V12z M8,6C7.4,6,7,5.6,7,5s0.4-1,1-1 s1,0.4,1,1S8.6,6,8,6z" />
);

export const InfoIcon = ({ size, ...props }: InfoIconProps) => {
  const SizedInfoIcon = ({ sizeInPixels }: { readonly sizeInPixels: number }) => (
    <BaseIcon width={sizeInPixels} height={sizeInPixels} viewBox="0 0 16 16" fill="none" {...props}>
      <path d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M9,12H7V7h2V12z M8,6C7.4,6,7,5.6,7,5s0.4-1,1-1 s1,0.4,1,1S8.6,6,8,6z" />
    </BaseIcon>
  );

  if (size === IconSize.Mini) {
    return <SizedInfoIcon sizeInPixels={16} />;
  }

  return <SizedInfoIcon sizeInPixels={24} />;
};

InfoIcon.displayName = 'InfoIcon';
